import { render, staticRenderFns } from "./SystemAction.vue?vue&type=template&id=3cb74448&"
import script from "./SystemAction.vue?vue&type=script&lang=ts&"
export * from "./SystemAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports